import { marked, type Tokens } from 'marked';

export const markdownToHtml = (markdown: string, checkIframe: boolean) => {
  marked.use({
    renderer: {
      paragraph(token: Tokens.Paragraph) {
        const text = this.parser.parseInline(token.tokens);
        return `<p>${text}</p>`;
      }
    },
    pedantic: true
  });
  if (checkIframe)
    markdown = markdown.replace(/<iframe src\b/gi, '<iframe class="lazyload" title="contenido" data-src');
  return marked.parse(markdown);
};
